module.exports = __webpack_public_path__ + "static/img/empty-business-card.f05d490.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty-business-card.svg
// module id = 203
// module chunks = 0